<template>
  <div class="formCom">
    <div class="form">
      <div class="header-content">
        <div class="day-label">
          <p>Inventory ({{ getLabel(getDays) }})</p> 
        </div>
        <button class="close" @click="closeModal">
          <CloseIcone></CloseIcone>
        </button>
      </div>
      <div class="editlog">
        <template v-if="!loading">
          <table class="styled-table">
            <thead>
              <tr>
                <th class="title-data"></th>
                <th class="title-data" v-for="kit in kitTypes" :key="`header-${kit}`">{{ kit }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Amazon</td>
                <td v-for="kit in kitTypes" :key="`amazon-${kit}`">{{ amazonCounts[kit] || 0 }}</td>
              </tr>
              <tr>
                <td>WWW Kits</td>
                <td v-for="kit in kitTypes" :key="`idlife-${kit}`">{{ idlifeCounts[kit] || 0 }}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td v-for="kit in kitTypes" :key="`total-${kit}`">{{ totalSums[kit] || 0 }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <template v-else>
          <div class="loader">Loading data, please wait...</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CloseIcone from "../../../images/shared/cancel";

export default {
  name: "InventoryTable",
  data() {
    return {
      kitTypes: ["F1", "F2", "F3", "R1", "R2", "R3"],
      loading: true, // Add a loading state
      title: {
        30: "30 Days",
        60: "60 Days",
        90: "90 Days",
        1: "Q1",
        2: "Q2",
        3: "Q3",
        4: "Q4",
        5: "YTD",
        0: "All"
      },
    };
  },
  computed: {
    ...mapGetters(["getKitCounts", "getFilterSalesdata", "getDays"]),
    amazonCounts() {
      const counts = this.kitTypes.reduce((acc, kit) => {
        acc[kit] = 0;
        return acc;
      }, {});
      const kitTypes = {
        B086D5RQ7N: "F1",
        B086D4464B: "F2",
        B086DCV9Q7: "F3",
        B0C7CXXSRH: "R1",
        B0C7D1RCQ4: "R2",
        B0C7D167SM: "R3",
      };

      if (!this.getFilterSalesdata) return counts; // Return empty counts if data isn't loaded yet
      this.getFilterSalesdata.forEach((item) => {
        const kitType = kitTypes[item.type];
        if (kitType && typeof item.order_count === "number") {
          counts[kitType] += item.order_count;
        }
      });
      return counts;
    },
    idlifeCounts() {
      return this.$store.getters.getKitCounts.idlife || {};
    },
    totalSums() {
      const totals = {};
      this.kitTypes.forEach((kit) => {
        totals[kit] = (this.amazonCounts[kit] || 0) + (this.idlifeCounts[kit] || 0);
      });
      return totals;
    },
  },
  watch: {
    getFilterSalesdata: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.loading = false; // Stop loading when data is available
        }
      },
    },
  },
  methods: {
    getLabel(value) {
      return this.title[value] || "0";
    },
    closeModal() {
      this.$emit("closeInv", false);
    },
  },
  components: {
    CloseIcone,
  },
};
</script>

<style scoped>
.header-content {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.day-label {
  position: absolute;
  left: 133px;
  top: 10px;
  font-family: TTNormsLight, sans-serif;
  color: #005eb8;
}
.loader {
  font-size: 16px;
  color: #005eb8;
  text-align: center;
  margin-top: 20px;
  font-family: TTNormsLight, sans-serif;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  padding: 8px;
}

th {
  background-color: #005eb8;
  color: #f5f7fa;
  text-align: left;
  font-family: TTNormsLight, sans-serif;
}
.headerp {
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
}
.header{
  margin-bottom: 2%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;
}
.container {
  padding-top: 30%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 200px; /* Adjust as needed for your layout */
}
.close {
  position: absolute;
  right: 15px;
  top: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding-top: 25px;
  background-color: #fff;
  max-width: 397px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
  font-size: 14px;
  font-family: TTNormsLight,sans-serif;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.sort-data{
  padding-left: 10px;
}
.sort-data .down {
  transform: rotate(180deg);
}
</style>
